var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_296)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.90631 13.6561C7.71647 13.4663 7.71647 13.1585 7.90631 12.9687L9.62503 11.2499L7.90631 9.53123C7.71647 9.34138 7.71647 9.03359 7.90631 8.84374C8.09616 8.6539 8.40395 8.6539 8.5938 8.84374L10.6563 10.9062C10.8461 11.096 10.8461 11.4038 10.6563 11.5937L8.5938 13.6561C8.40395 13.846 8.09616 13.846 7.90631 13.6561Z",
    fill: "#FF00E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09369 13.6561C5.28353 13.4663 5.28353 13.1585 5.09369 12.9687L3.37497 11.2499L5.09369 9.53123C5.28353 9.34138 5.28353 9.03359 5.09369 8.84374C4.90384 8.6539 4.59605 8.6539 4.4062 8.84374L2.34374 10.9062C2.1539 11.096 2.1539 11.4038 2.34374 11.5937L4.4062 13.6561C4.59605 13.846 4.90385 13.846 5.09369 13.6561Z",
    fill: "#FF00E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_296",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_296",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_296",
    x1: 1,
    y1: 1,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#62187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#601879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#5E1976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#5B1972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#571A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#531B66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#4E1C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#491D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#441E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#3E2049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#392141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#34223A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#2E2332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#2A242B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_296",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeFile);
export default __webpack_public_path__ + "static/media/code-file.0ce918569658f1e8363292b9ec5b0579.svg";
export { ForwardRef as ReactComponent };